module.exports = __webpack_public_path__ + "img/none.8e338a05.png";